import { createElement, Fragment } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const Qr = createSvg({
  name: 'qr',
  path: /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("path", {
    d: "M16.76 37.46c-.83 0-1.5-.67-1.5-1.5V18.53c0-1.93 1.57-3.5 3.5-3.5h17.43c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5H18.76c-.27 0-.5.23-.5.5v17.43c0 .83-.67 1.5-1.5 1.5zm19.43 31.51H18.76c-1.93 0-3.5-1.57-3.5-3.5V48.04c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v17.43c0 .27.23.5.5.5h17.43c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5zm31.05-31.51c-.83 0-1.5-.67-1.5-1.5V18.53c0-.27-.23-.5-.5-.5H47.81c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5h17.43c1.93 0 3.5 1.57 3.5 3.5v17.43c0 .83-.67 1.5-1.5 1.5zm-2 31.51H47.81c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5h17.43c.27 0 .5-.23.5-.5V48.04c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v17.43c0 1.93-1.57 3.5-3.5 3.5z"
  }), /*#__PURE__*/createElement("path", {
    d: "M40.73 40.52H24.29V24.08h16.44v16.44zm-13.44-3h10.44V27.08H27.29v10.44zm32.11 3H42.95V24.08H59.4v16.44zm-13.45-3H56.4V27.08H45.95v10.44zm-5.22 22.57H24.29V43.65h16.44v16.44zm-13.44-3h10.44V46.65H27.29v10.44z"
  }), /*#__PURE__*/createElement("path", {
    d: "M30.66 30.45h3.69v3.69h-3.69zm0 19.57h3.69v3.69h-3.69zm19.07 0h3.69v3.69h-3.69zm-5.22-5.26h3.69v3.69h-3.69zm10.45 0h3.69v3.69h-3.69zM44.51 55.51h3.69v3.69h-3.69zm10.45 0h3.69v3.69h-3.69zm-5.63-25.06h3.69v3.69h-3.69z"
  }))
});

export default Qr;
